import {Networking} from "../../../public/js/utils/Netwtorking";
import {LinkBuilder} from "../../../public/js/utils/LinkBuilder";
import {DOM} from "../../../public/js/utils/DOM";
import {CollectedValuesType} from "./definitions/CollectedValuesType";
import {IFormCreateRequestParameters} from "./definitions/IFormCreateRequestParameters";
import {RequestTypes} from "../../../public/js/definitions/utils/networking/RequestTypes";

export namespace ControlsForm {

    export class Controller {

        /**
         * Get data from form element
         * @param formElement - form HTML element
         * @param overrideParams - force replace some values from form
         */
        public static getFormData(formElement: HTMLElement, overrideParams: any = []) : CollectedValuesType {

            // Loop through all inputs
            const collectedFormValues: CollectedValuesType = [];
            const inputs = formElement.getElementsByTagName("input");
            for (let index = 0; index < inputs.length; ++index) {

                // Parse input attributes
                const input = inputs[index];
                if (input.classList.contains('select-dropdown')
                    || input.classList.contains('dropdown-input')
                    || input.classList.contains('items-placeholder')
                    || input.classList.contains('iti__search-input')
                    || input.classList.contains('DateTimePicker-generated')
                    || input.classList.contains('tomselect-checkbox')) { continue; }

                if (input.classList.contains('skip')) { continue; }
                const inputType = input.getAttribute("type");
                let inputName = input.getAttribute("name");
                const isInteger = input.dataset.integer;
                if (!inputName) { console.warn('Missing name on input:', input); continue; }
                inputName = inputName.replace("[]", "");
                const length = inputs[index].value.length;

                // Phone input - use data
                if (input.classList.contains('PhoneInput-input-input')) {
                    let data : string|null = DOM.Parser.getDataByNameFromElementOrNull('data', input);
                    collectedFormValues[inputName] = data && data.trim().length > 0 ? JSON.parse(data) : null;
                }

                // Radio - value of checked or null
                else if (inputType === "radio") {
                    if (input.checked) {
                        collectedFormValues[inputName] = isInteger ? parseInt(input.value) : input.value;
                    } else if (!collectedFormValues[inputName]) {
                        collectedFormValues[inputName] = null;
                    }
                }

                // Checkbox - checked true else null
                else if (inputType === "checkbox") {
                    collectedFormValues[inputName] = input.checked;
                }

                // Text, Password, hidden - string value or null
                else if ((inputType === "text" || inputType === "email" || inputType === 'password') && length > 0) {
                    collectedFormValues[inputName] = isInteger ? parseInt(input.value.trim()) : input.value.trim();
                }

                // Hidden
                else if ((inputType === 'hidden') && length > 0) {
                    collectedFormValues[inputName] = isInteger ? parseInt(input.value.trim()) : input.value.trim();
                }

                // Number - int value or null
                else if (inputType === "number" && length > 0) {
                    collectedFormValues[inputName] = parseInt(input.value.trim(), 10);
                }

                // Send empty value
                else {
                    collectedFormValues[inputName] = null;
                }
            }

            // Look through textarea inputs
            const areas = formElement.getElementsByTagName("textarea");
            for (let index = 0; index < areas.length; ++index) {

                // Save value
                const inputName = areas[index].getAttribute("name");
                if (!inputName) { console.warn("Missing name on textarea"); continue; }
                if (areas[index].classList.contains('skip')) { continue; }
                const length = areas[index].value.length;
                collectedFormValues[inputName] = length > 0 ? areas[index].value.trim() : null;
            }

            // Look through select inputs
            const selects = formElement.getElementsByTagName("select");
            for (let index = 0; index < selects.length; ++index) {

                // Save value
                let selectName = selects[index].getAttribute("name");
                const isInteger = selects[index].dataset.integer;
                if (!selectName) { console.warn("Missing name on select"); continue; }
                if (selects[index].classList.contains('skip')) { continue; }
                selectName = selectName.replace('[]', '');

                if (selects[index].classList.contains('multiChoose') || selects[index].multiple) {
                    let values = [];
                    for (let i=0, iLen=selects[index].options.length; i<iLen; i++) {
                        const option = selects[index].options[i];
                        if (option.selected) { values.push(isInteger ? parseInt(option.value.trim()) : option.value.trim()); }
                        collectedFormValues[selectName] = values;
                    }
                } else {
                    const length = selects[index].value.trim().length;
                    let value = length > 0 ? selects[index].value.trim() : null;
                    if (length > 0 && isInteger && value && value !== "0") { collectedFormValues[selectName] = parseInt(value); }
                    else if (value && length > 0 && value !== "0") { collectedFormValues[selectName] = value; }
                    else { collectedFormValues[selectName] = null; }
                }
            }

            return {...collectedFormValues, ...overrideParams};
        }

        /**
         * Disable all inputs in the form
         * @param formElement - main form element
         * @private
         */
        public static disableActionsInForm(formElement: HTMLFormElement): void {

            // Whole form changes
            formElement.style.opacity = '80%';
            formElement.style.pointerEvents = 'none';

            // Update inputs design update and submit disable
            const inputs = formElement.getElementsByTagName("input");
            for (let index = 0; index < inputs.length; ++index) {
                if (inputs[index].type === "submit") {
                    inputs[index].disabled = true;
                } else {
                    inputs[index].style.setProperty("border-color", "#9e9e9e", "important");
                }
            }

            // Update buttons disabled
            const buttons = formElement.getElementsByTagName("button");
            for (let index = 0; index < buttons.length; ++index) {
                buttons[index].disabled = true;
            }

            // Text area design update
            const areas = formElement.getElementsByTagName("textarea");
            for (let index = 0; index < areas.length; ++index) {
                areas[index].style.setProperty("border-color", "rgb(190,190,190)", "important");
            }
        }

        /**
         * Enable all inputs in the form
         * @param formElement - main form element
         * @private
         */
        public static enableActionsInForm(formElement: HTMLFormElement): void {

            // Whole form changes
            formElement.style.opacity = '100%';
            formElement.style.pointerEvents = 'auto';

            // Update inputs design update and submit disable
            const inputs = formElement.getElementsByTagName("input");
            for (let index = 0; index < inputs.length; ++index) {
                if (inputs[index].type === "submit") {
                    inputs[index].disabled = false;
                } else {
                    inputs[index].style.removeProperty("border-color");
                }
            }

            // Update buttons enabled
            const buttons = formElement.getElementsByTagName("button");
            for (let index = 0; index < buttons.length; ++index) {
                buttons[index].disabled = false;
            }

            // Text area design update
            const areas = formElement.getElementsByTagName("textarea");
            for (let index = 0; index < areas.length; ++index) {
                areas[index].style.removeProperty("border-color");
            }
        }

        /**
         * Wrapper for sending form through networking
         * @param requestParameters - all parameters required to send request
         * @param formElement - form element asking for action
         */
        public static async sendFormDataRequest(formElement: HTMLFormElement, requestParameters: IFormCreateRequestParameters): Promise<void> {

            requestParameters.event.stopPropagation(); requestParameters.event.preventDefault();
            const formId = formElement.getAttribute('id') as string;

            let link;
            if (requestParameters.linkParameters) {
                link = LinkBuilder.LinkBuilderController.composeLink(requestParameters.linkParameters);
            } else {
                link = formElement.getAttribute('action') + '';
            }

            await Networking.NetworkingController.createRequest({
                type: RequestTypes.POST,
                url: link,
                formData: requestParameters.formDataObject,
                disableButtons: requestParameters.forceDisabledButtons ? requestParameters.forceDisabledButtons : null,
                muteSuccess: requestParameters.muteSuccess,
                data: requestParameters.formData,
                successCallback: requestParameters.successCallback,
                startCallback: () => {
                    this.disableActionsInForm(formElement);
                    if (requestParameters.startCallback) { requestParameters.startCallback(); }
                },
                completedCallback: (payload?: any) => {
                    if ((!payload || !payload.redirect) && document.getElementById(formId)) {
                        this.enableActionsInForm(formElement);
                    }
                    if (requestParameters.completedCallback) { requestParameters.completedCallback(); }
                },
                errorCallback: requestParameters.errorCallback,
                snippetCallback: requestParameters.snippetCallback,
                silent: requestParameters.silent,
                dontProcessPayload: requestParameters.dontProcessPayload,
                rawJsonResponse: requestParameters.rawJsonResponse
            });
        }
    }
}
